






































import {
  liquidationPeriod,
  renewalTraduction
} from '@/util/transformString/translationsDecorator';
import { EnterpriceCommissions } from '@/store/interfaces/company';
import Vue, { PropType } from 'vue';
import { formatDate } from '@/util/filters';

export default Vue.extend({
  name: 'ShowCommissions',
  props: {
    commission: {
      required: true,
      type: Object as PropType<EnterpriceCommissions>,
    },
  },
  data: () => ({
    renewalTraduction,
    liquidationPeriod,
  }),
  computed: {
    startAtCommision(): string {
      return formatDate(this.commission.start_at);
    },
  },
});
